import React, { useState } from "react";
import "./LogoutModal.css";
import { reactIcons } from "../../../icons/reactIcons";
import Button from "../../../components/reusable-button/Button";
import { UserData } from "../../../routes/AppRoutes";
import { apiClient } from "../../../utils/apiClient";
import { useDispatch } from "react-redux";
import { setAuthToken } from "../../../redux/AuthReducer/AuthSlice";
import { useNavigate } from "react-router-dom";
interface LogoutModalProps {
  isOpen: boolean;
  onCancel: () => void;
  setIsAuthenticated: (data: UserData | null) => void;
}

const LogoutModal: React.FC<LogoutModalProps> = ({
  isOpen,
  onCancel,
  setIsAuthenticated,
}) => {
  const dispatcher = useDispatch();
  const navigate = useNavigate();

  //using the following state for loader
  const [loader, setLoader] = useState<boolean>(false);

  if (!isOpen) return null;

  const handleLogout = async (e: React.FormEvent) => {
    e.preventDefault();
    navigate("/login");
    dispatcher(setAuthToken(null));
    localStorage.removeItem("odessa_user_details");
    localStorage.removeItem("oc_all_in_termCodes");
    localStorage.removeItem("oc_all_in_FeatureName");
    setLoader(true);
    // try {
    //   let res = await apiClient.post(
    //     "https://odessa-dev.infojinicloud.com/api/v1/cms/authentication/logout",
    //   );
    //   console.log("res:", res);
    //   setIsAuthenticated(null);
    //   dispatcher(setAuthToken(null));
    //   localStorage.removeItem("odessa_user_details");
    //   navigate("/login");
    // } catch (error) {
    //   console.log("error:", error);
    // } finally {
    //   setLoader(false);
    // }
  };

  return (
    <div className="logout-modal-overlay">
      <form onSubmit={handleLogout}>
        <div className="logout-modal">
          <div className="logout-modal-header">
            <p className="logout-model-iconMain">
              <reactIcons.infoIcon className="logout-infoIcon" />
            </p>
            <h3 className="logout-modal-header-title">Log Out</h3>
          </div>
          <p className="logout-modal-body">Are you sure you want to Log Out?</p>
          <div className="logout-modal-footer">
            <div className="logout-model-cancelBtn">
              <Button text="Cancel" onClick={onCancel} type="button" />
            </div>
            <div className="logout-modal-submit">
              <Button
                text="Yes, Log Out"
                type="submit"
                disabled={loader}
                loading={loader}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LogoutModal;
